import { select, call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { apiServiceAsync } from '../services/apiService';
import {
  TActionTeamMythicPlusDungeonRunsRequested,
  TActionTeamMythicPlusRanksRequested,
  TActionTeamMythicPlusCalloutsRequested,
  TActionTeamMythicPlusProgressRequested,
  TActionTeamRosterRequested,
  TActionTeamDetailsRequested,
  TActionTeamLeaderboardRequested,
  ActionTypes,
  actions
} from './modules';
import { applicationIdsSelector, teamIdSelector } from './selectors';
import { RecruitmentEntityType } from '../../../../../shared/types/recruitmentTypes';

// Sagas
//

//
// view team leaderboard
//
function* viewTeamLeaderboard(action: TActionTeamLeaderboardRequested): any {
  const { instanceId } = action.payload;
  const { region, season, bracket, eventId, page, faction, pageSize } = action.payload.params;
  try {
    const results = yield call(apiServiceAsync.getTeamLeaderboard, {
      region,
      season,
      bracket,
      eventId,
      page,
      faction,
      pageSize
    });
    yield put(
      actions.setViewTeamLeaderboardSucceeded(instanceId, {
        region,
        season,
        bracket,
        eventId,
        page,
        pageSize,
        faction,
        results: results.viewTeamLeaderboardApi
      })
    );
  } catch (e) {
    yield put(
      actions.setViewTeamLeaderboardFailed(instanceId, {
        region,
        season,
        bracket,
        eventId,
        page,
        faction,
        error: e.toString()
      })
    );
  }
}

function* watchViewTeamLeaderboardRequested(): any {
  yield takeEvery(ActionTypes.SET_TEAM_LEADERBOARD_REQUESTED, viewTeamLeaderboard);
}

//
// view team details
//
function* viewTeamDetails(action: TActionTeamDetailsRequested): any {
  const { region, team } = action.payload;
  try {
    const results = yield call(apiServiceAsync.getTeamDetails, { region, team });

    yield put(
      actions.setViewTeamDetailsSucceeded({
        region,
        team,
        results: results.viewTeamDetailsApi
      })
    );
  } catch (e) {
    yield put(
      actions.setViewTeamDetailsFailed({
        region,
        team,
        error: e.toString()
      })
    );
  }
}

function* watchViewTeamDetailsRequested(): any {
  // TODO: should this be a `takeEvery` so if someone hits multiple create buttons it will create each one?
  yield takeLatest(ActionTypes.SET_TEAM_DETAILS_REQUESTED, viewTeamDetails);
}

//
// view team roster
//
function* viewTeamRoster(action: TActionTeamRosterRequested): any {
  const { region, team } = action.payload;
  try {
    const results = yield call(apiServiceAsync.getTeamRoster, { region, team });
    yield put(
      actions.setViewTeamRosterSucceeded({
        region,
        team,
        results: results.viewTeamRosterApi
      })
    );
  } catch (e) {
    yield put(
      actions.setViewTeamRosterFailed({
        region,
        team,
        error: e.toString()
      })
    );
  }
}

function* watchViewTeamRosterRequested(): any {
  // TODO: should this be a `takeEvery` so if someone hits multiple create buttons it will create each one?
  yield takeLatest(ActionTypes.SET_TEAM_ROSTER_REQUESTED, viewTeamRoster);
}

//
// view team mythic+ progress
//
function* viewTeamMythicPlusProgress(action: TActionTeamMythicPlusProgressRequested): any {
  const { season, team, region } = action.payload;
  try {
    const results = yield call(apiServiceAsync.getTeamMythicPlusProgress, { season, team, region });
    yield put(
      actions.setViewTeamMythicPlusProgressSucceeded({
        season,
        team,
        region,
        results: results.mythicPlusProgress
      })
    );
  } catch (e) {
    yield put(
      actions.setViewTeamMythicPlusProgressFailed({
        season,
        team,
        region,
        error: e.toString()
      })
    );
  }
}

function* watchViewTeamMythicPlusProgressRequested(): any {
  yield takeLatest(ActionTypes.SET_TEAM_MYTHICPLUS_PROGRESS_REQUESTED, viewTeamMythicPlusProgress);
}

//
// view team mythic+ callouts
//
function* viewTeamMythicPlusCallouts(action: TActionTeamMythicPlusCalloutsRequested): any {
  const { season, team, region } = action.payload;
  try {
    const results = yield call(apiServiceAsync.getTeamMythicPlusCallouts, { season, team, region });
    yield put(
      actions.setViewTeamMythicPlusCalloutsSucceeded({
        season,
        team,
        region,
        results: results.mythicPlusCallouts
      })
    );
  } catch (e) {
    yield put(
      actions.setViewTeamMythicPlusCalloutsFailed({
        season,
        team,
        region,
        error: e.toString()
      })
    );
  }
}

function* watchViewTeamMythicPlusCalloutsRequested(): any {
  yield takeLatest(ActionTypes.SET_TEAM_MYTHICPLUS_CALLOUTS_REQUESTED, viewTeamMythicPlusCallouts);
}

//
// view team mythic+ ranks
//
function* viewTeamMythicPlusRanks(action: TActionTeamMythicPlusRanksRequested): any {
  const { season, team, region } = action.payload;
  try {
    const results = yield call(apiServiceAsync.getTeamMythicPlusRanks, { season, team, region });
    yield put(
      actions.setViewTeamMythicPlusRanksSucceeded({
        season,
        team,
        region,
        results: results.mythicPlusRanks
      })
    );
  } catch (e) {
    yield put(
      actions.setViewTeamMythicPlusRanksFailed({
        season,
        team,
        region,
        error: e.toString()
      })
    );
  }
}

function* watchViewTeamMythicPlusRanksRequested(): any {
  yield takeLatest(ActionTypes.SET_TEAM_MYTHICPLUS_RANKS_REQUESTED, viewTeamMythicPlusRanks);
}

//
// view team mythic+ dungeon
//
function* viewTeamMythicPlusDungeonRuns(action: TActionTeamMythicPlusDungeonRunsRequested): any {
  const { season, team, region, dungeon } = action.payload;
  try {
    const results = yield call(apiServiceAsync.getTeamMythicPlusDungeonRuns, { season, team, region, dungeon });
    yield put(
      actions.setViewTeamMythicPlusDungeonRunsSucceeded({
        season,
        team,
        region,
        dungeon,
        results: results.viewTeamMythicPlusDungeonRunsApi
      })
    );
  } catch (e) {
    yield put(actions.setViewTeamMythicPlusDungeonRunsFailed({ season, team, region, dungeon, error: e.toString() }));
  }
}

function* watchViewTeamMythicPlusDungeonRunsRequested(): any {
  yield takeLatest(ActionTypes.SET_TEAM_MYTHICPLUS_DUNGEON_RUNS_REQUESTED, viewTeamMythicPlusDungeonRuns);
}

/* RECRUITMENT */
const {
  loadTeamRecruitmentProfileSuccess,
  loadTeamRecruitmentProfileFail,

  requestApplicationSuccess,
  requestApplicationFail
} = actions;

function* fetchTeamRecruitmentProfilesSaga(): any {
  const teamId = yield select(teamIdSelector);
  try {
    const { profiles } = yield call(apiServiceAsync.getTargetRecruitmentProfiles, RecruitmentEntityType.Team, teamId);
    yield put(loadTeamRecruitmentProfileSuccess(profiles));
  } catch (e) {
    yield put(loadTeamRecruitmentProfileFail());
  }
}

function* requestApplicationSaga(action: any): any {
  const applicationReq = yield select(applicationIdsSelector);
  try {
    const { recruitmentApplication } = yield call(apiServiceAsync.requestApplication, applicationReq);
    yield put(requestApplicationSuccess(recruitmentApplication.thread_id));
  } catch (e) {
    yield put(requestApplicationFail(e?.message));
  }
}

function* watchLoadTeamRecruitmentPage(): any {
  yield takeLatest(ActionTypes.LOAD_TEAM_RECRUITMENT_PROFILE, fetchTeamRecruitmentProfilesSaga);
}
function* watchRequestApplication(): any {
  yield takeLatest(ActionTypes.REQUEST_APPLICATION, requestApplicationSaga);
}
/* END RECRUITMENT */

//
// saga exports
//
export const sagas = [
  watchLoadTeamRecruitmentPage(),
  watchRequestApplication(),
  watchViewTeamLeaderboardRequested(),
  watchViewTeamDetailsRequested(),
  watchViewTeamMythicPlusProgressRequested(),
  watchViewTeamMythicPlusDungeonRunsRequested(),
  watchViewTeamRosterRequested(),
  watchViewTeamMythicPlusRanksRequested(),
  watchViewTeamMythicPlusCalloutsRequested()
];
